import React, { useState, useEffect, useContext, useMemo } from 'react';
import GlobalContext from '../../contexts/global.js';
import StateContext from '../../contexts/state.js';
import Listing from '../../components/Listing.js';
import PageBanner from '../../components/PageBanner.js';
import { changeBrowserTitle } from '../../hooks/headAmender.js';
import locationBadgeIcon from '../../helpers/locationBadgeIcon.js';
import categoryFilterGroup from '../../helpers/categoryFilterGroup.js';

const Partners = () => {
    const { globalContext } = useContext(GlobalContext);
    const { updateState } = useContext(StateContext);

    const [search, setSearch] = useState("");
    const [selectedCategories, setSelectedCategories] = useState([]);

    changeBrowserTitle(`Partners${ globalContext?.siteConfig?.siteName ? ` - ${ globalContext.siteConfig.siteName }` : "" }`);

    const filterGroups = useMemo(() => ([
        [{ key: "gradeName", value: "partners" }],
        ...categoryFilterGroup(selectedCategories)
    ]), [selectedCategories]);

    useEffect(() => {
        updateState({
            banner: (
                <PageBanner
                    crumbLabel="Partners"
                    title="Partners"
                    description="News and updates featuring our partners."
                    icon="people"
                    search={search}
                    onSearchChange={setSearch}
                    selectedCategories={selectedCategories}
                    onCategoriesChange={setSelectedCategories}
                />
            )
        });

        return () => {
            updateState({ banner: null });
        }
    }, [search, selectedCategories]);

    return (
        <section>
            <Listing
                filterGroups={filterGroups}
                search={search}
                initialCount={6}
                paginateBy={6}
                groupByDate={true}
                badgeKeys={[
                    { key: "los", icon: "people" },
                    { key: "location", icon: locationBadgeIcon }
                ]}
            />
        </section>
    );
};

export default Partners;
